export default __webpack_public_path__ + "static/media/efecto-4.f492782c.webp";